import { Record as record } from 'immutable';
import _ from 'lodash';

import trainTime from '../../lib/TrainTime';
import { resolve, resolveAll } from '../../helpers/LinkMapper';

import KeyGoJourneyPattern from './KeyGoJourneyPattern';

const defaults = _.zipObject([
    'transactionId',
    'dateTime',
    'description',
    'value',
    'balance',
    'reasonCode',
    'reasonDescription',
    'journeyPattern'
]);

class KeyGoTransaction extends record(defaults) {

    static fromJSON (json = {}) {
        const data = {
            transactionId: resolve(json.transactionId).with(Number),
            dateTime: resolve(json.dateTime).with(trainTime),
            description: resolve(json.description).with(String),
            value: resolve(json.value).with(Number),
            balance: resolve(json.balance).with(Number),
            reasonCode: resolve(json.reasonCode).with(String),
            reasonDescription: resolve(json.reasonDescription).with(String),
            journeyPattern: resolveAll(json.journeyPattern).as(KeyGoJourneyPattern)
        };
        return new KeyGoTransaction(data);
    }

    isDaily() { return this.description === "Daily Fares"; }

}

export default KeyGoTransaction;
